import {
  UPDATE_CALCULATED_SCORE,
  UPDATE_IS_REVIEW_SUBMITTED,
  UPDATE_IS_USER_SUBMITTING,
  UPDATE_IS_VALIDATION_ERROR,
  UPDATE_MANDATORY_ANSWERED,
  UPDATE_MANDATORY_COUNT,
  UPDATE_REVIEW_FORM_DRAFT_STATUS,
  UPDATE_REVIEW_TO_ID,
  UPDATE_REVIEW_TO_INFO,
  UPDATE_REVIEW_WRITER_INFO,
  UPDATE_SECTION_DATA,
  UPDATE_SECTION_LIST,
  UPDATE_REVIEW_TABS_DATA,
  UPDATE_SELECTED_REVIEW_TAB,
  UPDATE_IS_FETCHING_REVIEW_FORM_TABS,
  UPDATE_IS_FETCHING_REVIEW_FORM,
  RESET_REVIEW_FORM,
  UPDATE_IS_FORM_CONTAINS_TABULAR_VIEW,
  BATCH_UPDATE_TABLE_CELLS,
} from "./form.action";

const INITIAL_STATE = {
  // alias - reviewSubmitted
  isReviewSubmitted: null,

  // loading states
  isUserSubmitting: false,
  isFetchingReviewFormTabs: false,
  isFetchingReviewForm: false,

  // Meta of form

  // Draft status
  draftStatus: "",

  // Validation error
  isValidationError: false,

  // alias - review form
  // section list
  // sectionList is array of array
  // if its a section, its id is added at 0th index of a section
  sectionList: null,
  sectionData: null,

  blockInfo: {
    question: {
      // mandatoryCount is the number of mandatory questions
      // one time update
      mandatoryCount: 0,
      mandatoryAnswered: [],
    },
    goals: {
      mandatoryCount: 0,
      mandatoryAnswered: [],
    },
    competency: {
      mandatoryCount: 0,
      mandatoryAnswered: [],
    },
  },

  // Info about the user, the logged in user is viewing the form
  // Who is this review to?
  // Alias to reviewee details
  reviewToInfo: null,
  // Alias to reviewee id
  reviewToId: null,

  // the logged in user type info
  // Alias to reviewerTypeInfo
  reviewWriterInfo: null,

  reviewTabsData: null,
  selectedReviewTab: null,

  isFormContainsTabularView: false,
};

const form = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_IS_REVIEW_SUBMITTED: {
      return {
        ...state,
        isReviewSubmitted: action.payload,
      };
    }

    case UPDATE_IS_USER_SUBMITTING: {
      return {
        ...state,
        isUserSubmitting: action.payload,
      };
    }

    case UPDATE_REVIEW_FORM_DRAFT_STATUS: {
      return {
        ...state,
        draftStatus: action.payload,
      };
    }

    case UPDATE_IS_VALIDATION_ERROR: {
      return {
        ...state,
        isValidationError: action.payload,
      };
    }

    case UPDATE_SECTION_LIST: {
      return {
        ...state,
        sectionList: action.payload,
      };
    }

    case UPDATE_SECTION_DATA: {
      return {
        ...state,
        sectionData: action.payload,
      };
    }

    case UPDATE_MANDATORY_COUNT: {
      const { type, value } = action.payload;

      return {
        ...state,
        blockInfo: {
          ...state.blockInfo,
          [type]: {
            ...state.blockInfo[type],
            mandatoryCount: value,
          },
        },
      };
    }

    // Might be an array update
    case UPDATE_MANDATORY_ANSWERED: {
      const { type, value } = action.payload;

      return {
        ...state,
        blockInfo: {
          ...state.blockInfo,
          [type]: {
            ...state.blockInfo[type],
            mandatoryAnswered: value,
          },
        },
      };
    }

    case UPDATE_REVIEW_TO_INFO: {
      return {
        ...state,
        reviewToInfo: action.payload,
      };
    }

    case UPDATE_REVIEW_TO_ID: {
      return {
        ...state,
        reviewToId: action.payload,
      };
    }

    case UPDATE_REVIEW_WRITER_INFO: {
      return {
        ...state,
        reviewWriterInfo: action.payload,
      };
    }

    // Use to update calculated_question, overall goal score and overall competency score
    case UPDATE_CALCULATED_SCORE: {
      const { value } = action.payload;
      const sectionData = state.sectionData;

      let hasAnyChange = false;

      Object.keys(value).forEach((key) => {
        const block = sectionData[key];
        if (!block) return;

        const newScore = value[key].score;
        const newLegend = value[key].legend;

        if (block.score !== newScore || block.legend !== newLegend) {
          hasAnyChange = true;
          block.score = newScore;
          block.legend = newLegend;
        }
      });

      if (!hasAnyChange) return state;

      return {
        ...state,
        sectionData,
      };
    }

    case UPDATE_REVIEW_TABS_DATA: {
      return {
        ...state,
        reviewTabsData: action.payload,
      };
    }

    case UPDATE_SELECTED_REVIEW_TAB: {
      return {
        ...state,
        selectedReviewTab: action.payload,
      };
    }

    case UPDATE_IS_FETCHING_REVIEW_FORM_TABS: {
      return {
        ...state,
        isFetchingReviewFormTabs: action.payload,
      };
    }

    case UPDATE_IS_FETCHING_REVIEW_FORM: {
      return {
        ...state,
        isFetchingReviewForm: action.payload,
      };
    }

    case UPDATE_IS_FORM_CONTAINS_TABULAR_VIEW: {
      return {
        ...state,
        isFormContainsTabularView: action.payload,
      };
    }

    case BATCH_UPDATE_TABLE_CELLS: {
      const { blockId, updates } = action.payload;

      // Find the specific block by blockId
      // sectionData is an object with block id mapped to block
      const sectionData = state.sectionData;
      const targetBlock = sectionData[blockId];

      if (!targetBlock) {
        return state;
      }

      // Apply all updates to the block
      const updatedTableData = { ...targetBlock.block.table.table_data };

      // Process each cell update from the batch
      updates.forEach(({ rowId, columnKey, reviewerId, value }) => {
        // Check if the row and column exist in the table data
        if (updatedTableData[rowId] && updatedTableData[rowId][columnKey]) {
          updatedTableData[rowId] = {
            ...updatedTableData[rowId],
            // Update the column array by finding the reviewer's item and updating it
            [columnKey]: updatedTableData[rowId][columnKey].map(
              (item) =>
                // Find the item that belongs to this reviewer
                item.reviewer_id === reviewerId
                  ? {
                      ...item,
                      // Update based on column type: 'rating' (NPS) or 'comments' (text)
                      ...(columnKey === "rating"
                        ? {
                            // For NPS rating columns: update score and legend
                            score: value.score,
                            legend: value.legend,
                          }
                        : {
                            // For text comment columns: update response_text
                            response_text: value,
                          }),
                    }
                  : item // Keep other reviewers' data unchanged
            ),
          };
        }
      });

      // Update only the specific block - maintain the nested structure
      const updatedBlock = {
        ...targetBlock,
        block: {
          ...targetBlock.block,
          table: {
            ...targetBlock.block.table,
            table_data: updatedTableData,
          },
        },
      };

      return {
        ...state,
        sectionData: {
          ...state.sectionData,
          [blockId]: updatedBlock,
        },
      };
    }

    case RESET_REVIEW_FORM: {
      return INITIAL_STATE;
    }

    default:
      return state;
  }
};

export default form;
